import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const tabsMap = {
    APPLY: {
        code: "apply",
        display: "申请表",
    },
    FIRST_FLOW: {
        code: "flow1",
        display: "科片负责人审批",
    },
    SECOND_FLOW: {
        code: "flow2",
        display: "护理部审批",
    },
    REVIEW: {
        code: "review",
        display: "借调评价",
    },
};

const loanRangeMap = {
    BIG_UNIT: {
        label: "科片内调配",
        value: "bigUnit",
    },
    NURSE_UNIT: {
        label: "护理部调配",
        value: "nurseUnit",
    },
};

const mobileViewTitleMap = {
    [tabsMap.APPLY.code]: "科室当前情况",
    [tabsMap.FIRST_FLOW.code]: "科片负责人审批",
    [tabsMap.SECOND_FLOW.code]: "护理部审批",
};

const userRequirementMap = {
    DEPLOYED: {
        label: "由上级分配",
        value: "deployed",
    },
    SPECIFIED: {
        label: "指定人员",
        value: "specified",
    },
};

const itemCodes = {
    ASSIGN_USERS: "assignUsers",
    UNIT_NURSE_COUNT: "unitNurseCount",
    AGES: "ages",
    EDU_BGS: "eduBgs",
    EMPLOYEE_NATURES: "employeeNatures",
    EVL_JOB_TITLES: "evlJobTitles",
    EMP_JOB_TITLES: "empJobTitles",
    RANKS: "ranks",
    WORK_YEARS: "workYears",
    ROTATION_UNITS: "rotationUnits",
};
const archiveItems = [itemCodes.AGES, itemCodes.EDU_BGS, itemCodes.EMPLOYEE_NATURES, itemCodes.EVL_JOB_TITLES, itemCodes.EMP_JOB_TITLES, itemCodes.RANKS, itemCodes.WORK_YEARS];
const doNotShowOptions = [itemCodes.ASSIGN_USERS, itemCodes.ROTATION_UNITS];

const EmployeeSecondmentAuditType = {
    PRINCIPAL_DEPT: "PRINCIPAL_DEPT", // 科片负责人 -> 护理部
    DEPT: "DEPT", // 护理部
};

const initState = {

    selectedTab: tabsMap.APPLY.code,
    selectedLoanRange: loanRangeMap.BIG_UNIT.value,
    selectedRequirement: userRequirementMap.DEPLOYED.value,
    templateFinding: false, // 申请模板查找中
    applyTemplate: null, // 申请用模板

    employeeLoanApplyEditVisible: false, // 修改申请表

    flowSettingDrawerVisible: false, // 借调审批设置drawer
    flowLevel: null, // 借调审批流程级数

    reviewFormEditVisible: false, // 修改评价表
    reviewTemplate: null, // 评价表模板
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,

    tabsMap,
    mobileViewTitleMap,
    loanRangeMap,
    userRequirementMap,
    itemCodes,
    archiveItems,
    doNotShowOptions,
    EmployeeSecondmentAuditType,
};
export default viewModel;
